import { render, staticRenderFns } from "./BeliefMap.vue?vue&type=template&id=9251c850&scoped=true"
import script from "./BeliefMap.vue?vue&type=script&lang=js"
export * from "./BeliefMap.vue?vue&type=script&lang=js"
import style0 from "./BeliefMap.vue?vue&type=style&index=0&id=9251c850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9251c850",
  null
  
)

export default component.exports